<div class="layout-col full gap-lg">
  <mat-toolbar elderTheme color="primary" class="layout-row gap-md">
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>

    <span class="flex"></span>

    <button mat-flat-button color="accent" [disabled]="!selectedNode" (click)="close(selectedNode)">
      {{ 'actions.select' | translate }}
    </button>
  </mat-toolbar>

  <app-storage-node-browser
    class="flex"
    [browseOptions]="options"
    [interactionMode]="'selection'"
    [selectionVisible]="true"
    (selectionSingleChange)="selectedNode = $event"
  >
  </app-storage-node-browser>
</div>
